import React, { useState } from "react";
import Form from "components/Form";

import "./styles.scss";

export default function CPFImport({ data, onChange, isBulk }) {
  const [cpf, setCpf] = useState("");

  const addCPF = ({ target, key }, type) => {
    if ((key === "Enter" || type === "paste") && target.value) {
      onChange({
        inhabitant_segment: [
          ...data.inhabitant_segment,
          ...target.value
            .split(/[\s,]+/)
            .map((value) => ({ document_number: value })),
        ],
      });
      setCpf("");
    }
  };

  const updateCPF = ({ target }, index) => {
    const itensCopy = Array.from(data.inhabitant_segment);
    itensCopy.splice(index, 1, target.value);
    onChange({
      inhabitant_segment: itensCopy,
    });
  };

  const removeCPF = ({ target, key }, index) => {
    if (key === "Enter" && !target.value) {
      const itensCopy = Array.from(data.inhabitant_segment);
      itensCopy.splice(index, 1);
      onChange({
        inhabitant_segment: itensCopy,
      });
    }
  };

  return (
    <div className="pro-form">
      <Form.Field>
        <Form.Label htmlFor="input-add">
          Habitantes
          <Form.Input
            id="input-add"
            value={cpf}
            placeholder="Digite o CPF do cliente"
            className="pro-input-add input"
            onKeyDown={(event) => addCPF(event, "add")}
            onChange={({ target }) => setCpf(target.value)}
            disabled={isBulk}
          />
        </Form.Label>
      </Form.Field>

      <div className="pro-list-cpfs">
        {data.inhabitant_segment.map(({ document_number: value }, index) => (
          <Form.Label key={index} htmlFor="input-edit">
            <Form.Input
              id="input-edit"
              value={value}
              className={`pro-input-edit input ${
                (index + 1) % 2 === 0 && "odd"
              }`}
              onKeyDown={(event) => removeCPF(event, index)}
              onChange={(event) => updateCPF(event, index)}
            />
          </Form.Label>
        ))}
      </div>

      <div className="import-cpf-messages">
        <p>
          Para adicionar um novo cliente, digite seu CPF e pressione Enter
          <br />
          Para editar, apenas clique em cima do campo do CPF que deseje editar
          <br />
          Para remover, exclua todo o campo do CPF que deseje remover e
          pressione Enter
        </p>
      </div>
    </div>
  );
}
